import styled, { css } from 'styled-components';
import { blenderCss } from '@clds/blender';
import { focusRing } from '@clds/style-utils';
import { blenderStyleMixin } from './blender/blenderStyleMixin';
import { borderColorMixin } from './blender/borderColorMixin';
import { chipSizeVariant, chipTheme } from './theme';
export const Root = styled.div `
  ${blenderStyleMixin};
  background-color: ${blenderCss.backgroundFromCssVariables};
  border: none;
  ${focusRing(css `inset 0 0 0 1px ${borderColorMixin}`, 'background-color 200ms')};
  ${chipSizeVariant((variant) => blenderCss.typographyFromCssVariables(variant.typographySize))}
  outline-offset: -2px;
  display: inline-flex;
  /* fix for safari improperly measuring children height */
  min-height: -webkit-fit-content;
  align-items: center;
  border-radius: ${chipTheme.radius};
  padding: ${chipSizeVariant((branch) => `${branch.padding.vertical} ${branch.padding.horizontal}`)};
  white-space: nowrap;
  cursor: ${(props) => (props.isHoverable ? 'pointer' : 'inherit')};
`;
export const LeftWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-right: ${chipTheme.leftSlotSpacing};

  &:empty {
    display: none;
  }
`;
export const RightWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-left: ${chipTheme.rightSlotSpacing};

  &:empty {
    display: none;
  }
`;
//# sourceMappingURL=Chip.styled.js.map